import { extendTheme } from '@chakra-ui/react'

// Theme colors
const colors = {
  brand: {
    'primary': '#008AAC',
    'secondary': '#00596F',
    'green': '#008383',
  },
}

const config = {
  initialColorMode: 'dark',
  useSystemColorMode: false
}
  
  const theme = extendTheme({ colors, config })

  export default theme